/**
 * Custom FormBuilder adapter for VariableInlineInput.
 * Registered via `fieldRegistry` so it gets proper label, error, and FieldWrapper rendering.
 */
import { VariableInlineInput } from '@kula-ai/components';
import type { FieldAdapterProps } from '@kula-ai/components';

export function VariableInputAdapter({
  field,
  fieldState,
  config,
}: FieldAdapterProps) {
  const fp = (config.fieldProps ?? {}) as Record<string, unknown>;

  return (
    <VariableInlineInput
      value={String(field.value ?? '')}
      onChange={(v) => field.onChange(v)}
      placeholder={config.placeholder}
      disabled={!!config.disabled}
      readOnly={config.readOnly}
      error={!!fieldState?.error || !!fp.error}
      required={!!config.required}
      maxLength={config.maxLength}
      size={(fp.size as 'sm' | 'md') ?? 'md'}
      variables={fp.variables as Record<string, string[]> | undefined}
      allowedVariables={fp.allowedVariables as string[] | undefined}
      hideVariablePicker={fp.hideVariablePicker as boolean | undefined}
      showCount={fp.showCount as boolean | undefined}
    />
  );
}
